"use client";
import { useState } from "react";
import ShareBucketGrid from "./ShareBucketGrid";

export default function ShareModal({ schoolID, filters, onClose }) {
  const [copied, setCopied] = useState(false);
  const shareURL = typeof window !== "undefined"
    ? `${window.location.origin}/teacher/${schoolID}` : "";

  const handleCopy = () => {
    navigator.clipboard.writeText(shareURL).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: "fixed", inset: 0, zIndex: 1000,
        background: "rgba(15,23,42,0.6)", backdropFilter: "blur(4px)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: 20,
      }}
    >
      <link href="https://fonts.googleapis.com/css2?family=Fredoka+One&family=Nunito:wght@700;800;900&display=swap" rel="stylesheet" />
      <div style={{
        width: "min(95vw, 400px)",
        maxHeight: "90vh",
        borderRadius: 24,
        overflow: "hidden",
        overflowY: "auto",
        boxShadow: "0 25px 60px rgba(0,0,0,0.4)",
      }}>
        <ShareBucketGrid
          schoolID={schoolID}
          filters={filters}
          onCopyLink={handleCopy}
          copied={copied}
          onClose={onClose}
        />
      </div>
    </div>
  );
}